var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, observable } from 'mobx';
import { MandateType } from './index';
export default class Mandate {
    constructor(mandate) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "source", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "delegable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emtAccounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "diilAccounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "elionAccounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validFrom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validUntil", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "note", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLegal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.type === MandateType.LEGAL;
            }
        });
        Object.defineProperty(this, "isDiilMandate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.diilAccounts && this.diilAccounts.length > 0;
            }
        });
        makeObservable(this);
        Object.assign(this, mandate);
        this.validFrom = mandate.validFrom && new Date(this.validFrom);
        this.validUntil = mandate.validUntil && new Date(this.validUntil);
    }
}
__decorate([
    observable
], Mandate.prototype, "type", void 0);
__decorate([
    observable
], Mandate.prototype, "source", void 0);
__decorate([
    observable
], Mandate.prototype, "delegable", void 0);
__decorate([
    observable
], Mandate.prototype, "emtAccounts", void 0);
__decorate([
    observable
], Mandate.prototype, "diilAccounts", void 0);
__decorate([
    observable
], Mandate.prototype, "elionAccounts", void 0);
__decorate([
    observable
], Mandate.prototype, "validFrom", void 0);
__decorate([
    observable
], Mandate.prototype, "validUntil", void 0);
__decorate([
    observable
], Mandate.prototype, "note", void 0);
